<div class="performance-table-spinner d-flex align-items-center justify-content-center" *ngIf="isLoading">
  <c11n-spinner [size]="'medium'" [colorMode]="'on-light'" [spinnerStatus]="'Loading...'"></c11n-spinner>
</div>
<app-global-header *ngIf="!isLoading"></app-global-header>
<main *ngIf="isContentAvailable">
  <otel-instrumentation></otel-instrumentation>
  <router-outlet></router-outlet>
</main>
<main class="vgn-container default-padding" *ngIf="!isLoading && !isContentAvailable">
  <aem-error-page [FUND_LITERATURE_ERROR_SVG_URL]="findLiteratureErrorSvgUrl"
                  [FUND_LITERATURE_ERROR_HOME_URL]="findLiteratureErrorHomeUrl"></aem-error-page>
</main>
<app-global-footer *ngIf="!isLoading"></app-global-footer>
<div *ngIf="isCoverSpinner" id="cover-spin" class="fund-literature-table-spinner d-flex align-items-center justify-content-center">
  <c11n-spinner [size]="'medium'" [colorMode]="'on-light'" [spinnerStatus]="'Loading...'"></c11n-spinner>
</div>
